'use client'

import { useEffect } from 'react'

// Định nghĩa các key có thể có của insider_object
type InsiderKey =
  | 'basket'
  | 'page'
  | 'user'
  | 'listing'
  | 'transaction'
  | 'product'

// Interface cho insider_object với cả static và dynamic keys
interface InsiderObject {
  page?: { type: string }
  user?: {
    email: string
    name: string
    gdpr_optin: boolean
    email_optin: boolean
    phone_number: string
  }
  listing?: { items: unknown[] }
  basket?: unknown
  transaction?: unknown
  product?: unknown
  [key: string]: unknown
}

interface TrackingInsiderObjectProps {
  keyName: InsiderKey
  value: unknown
}

declare global {
  interface Window {
    insider_object: InsiderObject
  }
}

export const TrackingInsiderObject = ({
  keyName,
  value,
}: TrackingInsiderObjectProps) => {
  useEffect(() => {
    if (typeof window === 'undefined') return

    // Khởi tạo insider_object nếu chưa tồn tại để tránh lỗi runtime.
    window.insider_object = window.insider_object || {}

    switch (keyName) {
      case 'page':
        window.insider_object.page = value as { type: string }
        break
      case 'user':
        window.insider_object.user = value as {
          email: string
          name: string
          gdpr_optin: boolean
          email_optin: boolean
          phone_number: string
        }
        break
      case 'listing':
        window.insider_object.listing = value as { items: unknown[] }
        break
      case 'basket':
        window.insider_object.basket = value
        break
      case 'transaction':
        window.insider_object.transaction = value
        // InsiderTracker không tự re-initialize trên Confirmation page.
        // Trigger ở đây để đảm bảo transaction luôn được set trước khi Insider đọc.
        setTimeout(() => {
          window?.Insider?.eventManager?.dispatch?.('init-manager:re-initialize')
        }, 300)
        break
      case 'product':
        window.insider_object.product = value
        break
    }

    // Khi rời khỏi success page, xóa transaction khỏi window.insider_object
    // để tránh re-initialize lần sau đọc lại stale data và phát sinh empty/duplicate log.
    if (keyName === 'transaction') {
      return () => {
        if (window.insider_object) {
          delete window.insider_object.transaction
        }
      }
    }
  }, [keyName, value])

  return null
}
